export default "__VITE_ASSET__242c48c6__"